import { DateTime } from 'luxon'

export function getOnChangeFunction (setStateFunction, stateObject = {}) {
  if (typeof setStateFunction === 'function') {
    return (e) => {
      stateObject[e.target.name] = e.target.type === 'checkbox' ? e.target.checked : e.target.value
      setStateFunction((s) => ({ ...s, ...stateObject }))
    }
  }
}

export function parseDate (date, time = true) {
  if (date) {
    const parsedDate = date ? DateTime.fromISO(date).setZone('America/Mexico_City').toJSDate() : DateTime.now().setZone('America/Mexico_City').toJSDate()
    return `${parsedDate.toLocaleDateString('es-MX')} ${time ? parsedDate.toLocaleTimeString('es-MX') : ''}`
  }
  return ''
};

/**
 * Formats an ISO date string to YYYY-MM-DDTHH:mm format for datetime-local input
 * @param {string} isoDateString - ISO date string (e.g., "2025-09-26T13:21:16.417-06:00")
 * @returns {string} Formatted date string (e.g., "2025-09-26T13:21")
 */
export function formatDateForInput (isoDateString) {
  if (!isoDateString) return ''

  try {
    // Parse the ISO date and convert to local timezone
    const dateTime = DateTime.fromISO(isoDateString)

    // Format to YYYY-MM-DDTHH:mm (required format for datetime-local input)
    return dateTime.toFormat('yyyy-MM-dd\'T\'HH:mm')
  } catch (error) {
    console.error('Error formatting date for input:', error)
    return ''
  }
}

export function formatNumbers (n) {
  if (n) {
    const formatter = new Intl.NumberFormat('es-MX', {
      style: 'decimal',
      maximumFractionDigits: 2
    })

    return formatter.format(Number(n))
  }
  return ''
}

export const calculateNetHours = (startTime, endTime) => {
  const start = new Date(`1970-01-01T${startTime}Z`)
  const end = new Date(`1970-01-01T${endTime}Z`)
  // @ts-ignore
  const diff = (end - start) / (1000 * 60 * 60)
  return diff.toFixed(2)
}

// consder move to passwordUtils
export const generatePassword = (length = 8) =>
  Array.from({ length }, () => 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    .charAt(Math.floor(Math.random() * 62))).join('')

export const formatPermissionName = (permissionName) => {
  return permissionName
    .toLowerCase()
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export const formatRoleName = (name = '') => {
  return name
    .replace(/([A-Z])/g, ' $1')
    .trim()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export const getFormattedMissingFieldsMessage = (formData, requiredFields = []) => {
  const missingFields = getMissingFields(formData, requiredFields)

  if (!missingFields.length) return ''

  return formatMissingFieldsMessage(missingFields)
}

const getMissingFields = (formData, requiredFields = []) => {
  return requiredFields.filter(key => {
    const value = formData[key]
    if (typeof value === 'string') return value.trim() === ''
    return value === undefined || value === null || value === ''
  })
}

const formatMissingFieldsMessage = (fields) => {
  const formatKey = key =>
    key
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
      .replace(/^./, c => c.toUpperCase())

  const listItems = fields.map(key =>
    `<li class="mb-1">${formatKey(key)}</li>`
  ).join('')

  return `
    <div class="text-left text-sm">
      <p class="text-greenPrimary font-semibold mb-2">The following field${fields.length > 1 ? 's are' : ' is'} required:</p>
      <ul class="list-disc ml-5">
        ${listItems}
      </ul>
    </div>
  `
}
